import { createSelector } from '@ngrx/store';

import * as Utils from '@shared/core/utils';

import { getOnlineOrderState } from '../../../onlineOrder/selectors/getOnlineOrderState';
import { orderTypesState } from '../../../orderTypes/selectors/root';

export const isOrderTypeValid = createSelector(getOnlineOrderState, orderTypesState, (onlineOrder, orderTypes) => {
    const ot = onlineOrder.orderType;
    if (ot === null && onlineOrder?.data?.PickupLocation && orderTypes?.data) {
        return orderTypes.data.map((type) => type.Id).includes(onlineOrder.data.PickupLocation);
    }
    if (!ot) return false;

    const pageConfig = Utils.DynamicPages.customPageSetup('checkoutPage', ot?.Id);
    const disclaimersLength = ot.Disclaimers.length;
    const hasAnyDisclaimers: boolean = pageConfig.orderTypesDisclaimers === true && disclaimersLength >= 1;
    const isDisclaimerValid: boolean = Utils.OnlineOrders.isOrderTypeDisclaimerValid(ot, pageConfig?.orderTypesDisclaimers);
    const areAllDisclaimersValid = ot.Disclaimers.every((disclaimer) => !disclaimer.IsRequired || disclaimer._Value);
    const hasRequired = ot.Details.some((obj) => obj.IsRequired === true);
    const areAllFieldsValid = ot.Details.reduce((flag, field) => {
        if (flag === false) return false;
        if (field.IsRequired && !!field._Value === false) {
            return false;
        }

        return true;
    }, isDisclaimerValid);
    const hasNothingRequired = !hasRequired && !hasAnyDisclaimers;
    const isEverythingRequiredValid = (!hasAnyDisclaimers || areAllDisclaimersValid) && areAllFieldsValid;

    return hasNothingRequired || isEverythingRequiredValid;
});
